import { SkeletonTexts } from "~/components/skeletons/skeleton-texts";
import { SkeletonTextVariant } from "~/components/skeletons/skeleton-text";
import { EmptyPanel } from "./empty-panel";

export interface EmptyTextProps {
  title: string;
  text: string;
  variant?: SkeletonTextVariant;
  buttons?: React.ReactNode[];
}

export const EmptyText = ({
  title,
  text,
  variant,
  buttons,
}: EmptyTextProps) => {
  return (
    <EmptyPanel
      image={<SkeletonTexts variant={variant} />}
      title={title}
      text={text}
      buttons={buttons}
    />
  );
};
